import { render, staticRenderFns } from "./assistant-layout.vue?vue&type=template&id=2c84dc66&"
import script from "./assistant-layout.vue?vue&type=script&lang=js&"
export * from "./assistant-layout.vue?vue&type=script&lang=js&"
import style0 from "./assistant-layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {ReportStatusWatcher: require('/lasso/components/reports/ReportStatusWatcher.vue').default,RfiImportStatusWatcher: require('/lasso/components/templates/RfiImportStatusWatcher.vue').default,NavMobile: require('/lasso/components/NavMobile.vue').default,Header: require('/lasso/components/Header.vue').default,Error: require('/lasso/components/Error.vue').default,PageHeader: require('/lasso/components/PageHeader.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c84dc66')) {
      api.createRecord('2c84dc66', component.options)
    } else {
      api.reload('2c84dc66', component.options)
    }
    module.hot.accept("./assistant-layout.vue?vue&type=template&id=2c84dc66&", function () {
      api.rerender('2c84dc66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layouts/assistant-layout.vue"
export default component.exports